<template>
  <div class="body mx-auto">
    <v-row dense class="pa-2">
      <v-col cols="12"
        ><div dense class="titles">
          <span class="text-h6 font-weight-bold" style="color: #643a6b"> 今日事件 </span>
          <v-btn class="mx-4 white--text" @click="handleDialog" color="#313866">
            <v-icon>mdi-calendar-plus</v-icon>新增</v-btn
          >
        </div></v-col
      >
      <v-col
        v-for="(eventList, type) in groupedEvents()"
        :key="type"
        cols="12"
        sm="6"
        lg="3"
        class="px-2"
      >
        <v-card
          :color="
            type === '隔離'
              ? '#0E21A0'
              : type === '探視'
              ? '#4D2DB7'
              : type === '請假'
              ? '#9D44C0'
              : '#EC53B0'
          "
          rounded="lg"
          min-height="250"
          height="100%"
        >
          <v-card-title class="pa-2 white--text font-weight-bold">
            {{ type }}
          </v-card-title>
          <v-divider class="mx-2 my-0 white--text" />
          <v-card-text class="pa-2 white--text">
            <v-list dense class="transparent">
              <v-list-item
                v-for="eventItem in eventList"
                :key="eventItem.event_id"
                class="ma-1 white--text"
                @click="openEventDialog(eventItem)"
              >
                <v-list-item-icon class="mr-0">
                  <v-icon color="white">mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-subtitle-1 white--text"
                    style="white-space: normal; word-break: break-word"
                  >
                    {{ eventItem.label.split('｜').slice(0, 2).join('｜') }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="white--text text-subtitle-1">
                    {{ eventItem.label.split('｜')[2] }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="flex-shrink-0 d-flex flex-row">
                  <v-btn icon small @click.stop="copyEvent(eventItem)" class="white--text">
                    <v-icon color="white">mdi-content-copy</v-icon>
                  </v-btn>
                  <v-btn icon small @click.stop="deleteEvent(eventItem)" class="white--text">
                    <v-icon color="white">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense class="pa-2">
      <v-col cols="12">
        <div dense class="titles">
          <span class="text-h6 font-weight-bold" style="color: #643a6b"> 一週事件 </span>
          <v-btn class="mx-4 white--text" @click="handleDialog" color="#313866"
            ><v-icon>mdi-calendar-plus</v-icon>新增</v-btn
          >
        </div>
      </v-col>
      <v-col v-for="(day, index) in 6" :key="index" cols="6" sm="4" class="pa-2">
        <v-card min-height="250" height="100%" width="100%" rounded="xl" class="pa-1">
          <v-card-title class="pa-2 font-weight-bold justify-center text-h5">
            {{ getDays(index) }}
          </v-card-title>
          <v-divider class="ma-0" />
          <v-card-text class="pa-1 d-flex flex-wrap">
            <v-col
              v-for="event in getEventsForDay(getDate(index))"
              :key="event.id"
              class="px-0 py-1"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    v-on="on"
                    :color="
                      event.event_type === '隔離'
                        ? '#0E21A0'
                        : event.event_type === '探視'
                        ? '#4D2DB7'
                        : event.event_type === '請假'
                        ? '#9D44C0'
                        : '#EC53B0'
                    "
                    class="white--text text-body-1"
                    @click="openWeeklyEventDialog(event)"
                  >
                    {{ listEvents(event) }}
                    <v-btn
                      icon
                      x-small
                      class="ml-2 white--text"
                      @click.stop="copyWeeklyEvent(event)"
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      x-small
                      class="ml-2 white--text"
                      @click.stop="deleteWeeklyEvent(event)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-chip>
                </template>
                <div>
                  建立者：
                  <span class="font-weight-bold">{{ event.employee_name }}</span>
                </div>
              </v-tooltip>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense class="pa-2">
      <v-col cols="12">
        <div dense class="titles">
          <span class="text-h6 font-weight-bold" style="color: #643a6b"> 備忘錄 </span>
          <v-btn color="#313866" class="white--text mx-4" @click="openMemoEdit">
            <v-icon>mdi-pencil</v-icon>編輯
          </v-btn>
        </div>
      </v-col>
      <v-col>
        <v-card class="memo-display" min-height="200" color="amber lighten-4">
          <v-card-text class="text-h6 font-weight-bold black--text">
            <div>{{ memoContent }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" width="500">
      <v-card class="pa-2">
        <v-card-title class="headline">{{ isEditing ? '編輯事件' : '新增事件' }}</v-card-title>
        <v-card-text class="pa-2">
          <v-form ref="eventForm" v-model="valid" lazy-validation>
            <v-row dense>
              <v-col cols="12" class="pa-2">
                <v-select
                  outlined
                  dense
                  :items="names"
                  label="選擇個案"
                  hide-details=""
                  v-model="case_name"
                  @change="getCaseNum"
                  :disabled="isEditing"
                ></v-select>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-select
                  outlined
                  dense
                  :items="eventTypes"
                  label="事件類型"
                  hide-details=""
                  v-model="event_type"
                  :rules="[(v) => !!v || '請選擇事件類型']"
                ></v-select>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-text-field
                  outlined
                  dense
                  label="事由"
                  hide-details=""
                  v-model="description"
                  :rules="[(v) => !!v || '請輸入事由']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-menu
                  v-if="!isMobile"
                  ref="startMenu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      v-model="startDate"
                      label="起始日期"
                      hide-details=""
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" @input="startMenu = false"></v-date-picker>
                </v-menu>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="startDateForMobile"
                  label="起始日期"
                  hide-details=""
                  type="date"
                  @input="handleStartDateChange"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-select
                  outlined
                  dense
                  :items="timeOptions"
                  label="起始時間"
                  hide-details=""
                  v-model="startTime"
                  @change="setEndTime"
                ></v-select>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-menu
                  v-if="!isMobile"
                  ref="endMenu"
                  v-model="endMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      v-model="endDate"
                      label="結束日期"
                      hide-details=""
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :disabled="handleSelect"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" @input="endMenu = false"></v-date-picker>
                </v-menu>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="endDateForMobile"
                  label="結束日期"
                  hide-details=""
                  type="date"
                  :disabled="handleSelect"
                  @input="handleEndDateChange"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-select
                  outlined
                  dense
                  :items="timeOptions"
                  label="結束時間"
                  hide-details=""
                  v-model="endTime"
                  :disabled="handleSelect"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-2 justify-center">
          <v-btn color="blue" class="white--text" @click="isEditing ? updateEvent() : addEvents()">
            {{ isEditing ? '更新' : '送出' }}
          </v-btn>
          <v-btn text @click="closeDialog">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMemoEdit" max-width="600px">
      <v-card>
        <v-card-title class="text-h5">編輯備忘錄</v-card-title>
        <v-card-text>
          <v-textarea
            outlined
            v-model="editMemoContent"
            placeholder="請輸入內容..."
            rows="10"
            auto-grow
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogMemoEdit = false">取消</v-btn>
          <v-btn color="blue darken-1" text @click="saveMemo">送出</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteConfirmDialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h5">確認刪除此事件嗎？</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteConfirmDialog = false">取消</v-btn>
          <v-btn color="red" text @click="confirmDelete">確定刪除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-row dense class="pa-2">
      <v-col cols="12">
        <div>
          <v-btn color="#141E46" class="white--text"> 2024-10 </v-btn>
          <span class="text-h6 font-weight-bold" style="color: #643a6b"> 月長輩異常狀況統計 </span>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="4" v-for="stat in stats" :key="stat.label" class="stat-item">
        <v-icon large class="mr-2">{{ stat.icon }}</v-icon>
        {{ stat.label }}
        <div class="font-weight-bold" style="padding: 10px; color: red">
          {{ stat.value }}
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <div>
          <span class="text-h6 font-weight-bold" style="color: #643a6b">
            非計畫性住院高風險名單
          </span>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="3"
        v-for="(role, index) in highRiskList"
        :key="index"
        class="pa-4"
      >
        <v-card hover class="high-risk-card">
          <v-card-title class="pa-0 pa-sm-2 justify-center text-h6 font-weight-bold">
            <span class="card-title" style="color: #0079ff">
              {{ role.name }}
            </span>
          </v-card-title>
          <v-card-actions class="pa-0">
            <v-row no-gutters align="center">
              <v-col>
                <div class="text-center">
                  <v-icon :style="'color:red'">
                    {{ 'mdi-emoticon-sad-outline' }}
                  </v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text
            class="px-1 py-2 justify-center text-subtitle-1 font-weight-bold black--text"
          >
            <v-row no-gutters class="text-center">
              <v-col cols="6">
                <v-row no-gutters justify="center" align="center">
                  <v-icon color="#f44336">mdi-heart-pulse</v-icon>
                  <div v-if="role.blood_pressure != ''">{{ role.blood_pressure }} mmHg</div>
                  <div v-else>無資料</div>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters justify="center" align="center">
                  <v-icon color="#d32f2f">mdi-thermometer</v-icon>
                  <div v-if="role.temperature != ''">{{ role.temperature }} °C</div>
                  <div v-else>無資料</div>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
const moment = require('moment')
export default {
  data() {
    return {
      staff_id: '',
      dialog: false,
      eventTypes: ['送醫', '請假', '探視', '隔離'],
      event_type: '',
      description: '',
      case_name: '',
      case_num: '',
      dataList: [],
      startDate: new Date().toLocaleDateString().replaceAll('/', '-'),
      endDate: new Date().toLocaleDateString().replaceAll('/', '-'),
      startTime: '',
      endTime: '',
      startMenu: false,
      endMenu: false,
      timeOptions: this.generateTimeOptions(),
      startDateForMobile: '',
      endDateForMobile: '',
      events: [],
      handleSelect: false,
      memoContent: '',
      editMemoContent: '',
      dialogMemoEdit: false,
      selectedEvent: null,
      isEditing: false,
      valid: true,
      deleteConfirmDialog: false,
      eventToDelete: null,
      isMobile: false,

      // 異常統計資料
      stats: [
        { label: '跌倒', icon: 'mdi-alert', value: '' },
        { label: '走失', icon: 'mdi-run', value: '' },
        { label: '體溫', icon: 'mdi-thermometer', value: '' },
        { label: '心率', icon: 'mdi-heart-pulse', value: '' },
        { label: '血壓', icon: 'mdi-heart', value: '' },
        { label: '血氧', icon: 'mdi-percent', value: '' },
        { label: '血糖', icon: 'mdi-blood-bag', value: '' },
        { label: '體重', icon: 'mdi-weight', value: '' },
      ],

      // 非計畫住院高風險名單
      highRiskList: [
        // test data
        // {
        //   name: "吳O東",
        //   temperature: "36.5",
        //   blood_pressure: "120/80",
        //   heart_rate: "67",
        // },
      ],
    }
  },
  methods: {
    async getAlertCount() {
      const axios = require('axios')
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: '/api/attendance/get_irregular_event_count',
        headers: {},
      }
      try {
        let res = await axios.request(config)
        console.log(res.data)
        this.stats = res.data.data
      } catch (error) {
        console.log(error)
      }
    },
    async getCaseList() {
      const axios = require('axios')
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: '/api/attendance/name_corresponding/',
        headers: {},
      }
      try {
        let res = await axios.request(config)
        this.dataList = res.data
      } catch (error) {
        console.log(error)
      }
    },
    async getEvents() {
      const now = new Date()
      let formattedTime = moment(now).format()
      const encodedISOString = encodeURIComponent(formattedTime)
      const axios = require('axios')
      let config = {
        method: 'get',
        url: '/api/attendance/bulletin/?datetime=' + encodedISOString,
        header: {},
      }
      try {
        let res = await axios.request(config)
        console.log(res.data)
        this.events = res.data
      } catch (error) {
        console.log(error)
      }
    },
    async addEvents() {
      if (!this.$refs.eventForm.validate()) return

      let start = moment(this.startDate + ' ' + this.startTime, 'YYYY-M-DD HH:mm').toDate()
      let end = moment(this.endDate + ' ' + this.endTime, 'YYYY-M-DD HH:mm').toDate()
      // let end = moment(start).add(1, "hours").toDate();
      let formattedStart = moment(start).format()
      let formattedEnd = moment(end).format()
      const encodedStart = encodeURIComponent(formattedStart)
      const encodedEnd = encodeURIComponent(formattedEnd)
      const axios = require('axios')
      const qs = require('qs')
      let data = qs.stringify({
        event_type: this.event_type,
        description: this.description,
        start: formattedStart,
        end: formattedEnd,
        employee_id: this.staff_id,
      })

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `/api/attendance/events/${this.case_num}/`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data,
      }
      try {
        let res = await axios.request(config)
        console.log(res.data)
        this.getEvents()
        this.dialog = false
      } catch (error) {
        console.log(error)
      }
    },
    async getHighReiskList() {
      const axios = require('axios')
      const now = new Date()
      let formattedTime = moment(now).format()
      const encodedISOString = encodeURIComponent(formattedTime)

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: '/api/attendance/get_high_risk_persons/?datetime=' + encodedISOString,
        header: {},
      }
      try {
        let res = await axios.request(config)
        console.log(res.data)
        this.highRiskList = res.data.data
      } catch (error) {
        console.log(error)
      }
    },
    getCaseNum() {
      this.case_num = this.dataList.find((item) => item.name === this.case_name)?.case_num
      console.log(this.case_num)
    },
    setEndTime() {
      this.endDate = this.startDate
      if (this.isMobile) {
        this.endDateForMobile = this.startDateForMobile
      }
      if (this.event_type === '探視') {
        this.endTime = moment(this.startDate + ' ' + this.startTime)
          .add(1, 'hours')
          .format('HH:mm')
        if (!this.timeOptions.includes(this.endTime)) {
          this.timeOptions.push(this.endTime)
          this.timeOptions.sort()
        }
        this.handleSelect = true
      }
    },
    handleDialog() {
      this.isEditing = false
      this.case_name = ''
      this.case_num = ''
      this.event_type = ''
      this.description = ''
      const today = new Date().toLocaleDateString().replaceAll('/', '-')
      this.startDate = today
      this.endDate = today
      this.startDateForMobile = this.formatDateForInput(today)
      this.endDateForMobile = this.formatDateForInput(today)
      this.startTime = ''
      this.endTime = ''
      this.handleSelect = false
      this.dialog = true
    },
    formatDateForInput(dateString) {
      const parts = dateString.split('-')
      if (parts.length === 3) {
        const year = parts[0]
        const month = parts[1].padStart(2, '0')
        const day = parts[2].padStart(2, '0')
        return `${year}-${month}-${day}`
      }
      return dateString
    },
    formatDateFromInput(dateString) {
      const parts = dateString.split('-')
      if (parts.length === 3) {
        const year = parts[0]
        const month = parseInt(parts[1], 10).toString()
        const day = parseInt(parts[2], 10).toString()
        return `${year}-${month}-${day}`
      }
      return dateString
    },
    handleStartDateChange(value) {
      this.startDate = this.formatDateFromInput(value)
    },
    handleEndDateChange(value) {
      this.endDate = this.formatDateFromInput(value)
    },
    detectMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
      const isAndroid = /android/i.test(userAgent)
      const isMobileWidth = window.innerWidth <= 768
      this.isMobile = isIOS || isAndroid || isMobileWidth
    },
    generateTimeOptions() {
      const options = []
      for (let i = 8; i <= 17; i++) {
        const time = i < 10 ? `0${i}:00` : `${i}:00`
        options.push(time)
      }
      return options
    },
    getDays(index) {
      if (index == 0) {
        return '明日'
      } else {
        const date = new Date()
        date.setDate(date.getDate() + index + 1)
        const month = date.getMonth() + 1
        const day = date.getDate()
        return `${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
      }
    },
    getDate(index) {
      const date = new Date()
      date.setDate(date.getDate() + index + 1)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    },
    getEventsForDay(date) {
      const filteredEvents = this.events.filter((event) => {
        // Transfer string to object to manipulate date at locale timezone
        const eventLocalStart = moment(event.start).format('YYYY-MM-DD')
        const eventLocalEnd = moment(event.end).format('YYYY-MM-DD')
        const titleDate = moment(date).format('YYYY-MM-DD')
        console.log(titleDate, eventLocalStart, eventLocalEnd)
        if (titleDate >= eventLocalStart && titleDate <= eventLocalEnd) {
          return true
        }
        return false
      })
      console.log(filteredEvents)
      return filteredEvents
    },
    groupedEvents() {
      const today = moment().startOf('day')
      const groups = { 送醫: [], 請假: [], 探視: [], 隔離: [] }
      this.events.forEach((event) => {
        const start = moment.utc(event.start).local()
        const end = moment.utc(event.end).local()
        if (today.isBetween(start.clone().startOf('day'), end.clone().endOf('day'), null, '[]')) {
          let label = ''
          // 跨日事件
          if (!start.isSame(end, 'day')) {
            if (today.isSame(start, 'day')) {
              label = `${event.person} ｜ ${event.description}｜${start.format('HH:mm')} - 23:59`
            } else if (today.isSame(end, 'day')) {
              label = `${event.person} ｜ ${event.description}｜00:00 - ${end.format('HH:mm')}`
            } else {
              label = `${event.person} ｜ ${event.description}｜00:00 - 23:59`
            }
          } else {
            // 當日事件
            label = `${event.person} ｜ ${event.description}｜${start.format(
              'HH:mm'
            )} - ${end.format('HH:mm')}`
          }
          if (groups.hasOwnProperty(event.event_type)) {
            groups[event.event_type].push({
              label: label,
              event_id: event.event_id,
              event: event,
            })
          }
        }
      })
      return groups
    },
    listEvents(event) {
      return event.description && event.description.trim() !== ''
        ? `${event.person} ｜ ${event.description}`
        : `${event.person}`
    },
    openMemoEdit() {
      this.editMemoContent = this.memoContent
      this.dialogMemoEdit = true
    },
    async getMemo() {
      const axios = require('axios')
      let config = {
        method: 'get',
        url: '/api/attendance/text_memo/?datetime=' + this.startDate,
        header: {},
      }
      try {
        let res = await axios.request(config)
        this.memoContent = res.data.data
      } catch (error) {
        console.log(error)
      }
    },
    async getStaffName() {
      const axios = require('axios')
      const qs = require('qs')
      const staff = localStorage.getItem('staff')
      const staff_id = JSON.parse(staff).id
      let config = {
        method: 'get',
        url: `/api/attendance/get_employee_name?employee_id=${staff_id}`,
        header: {},
      }
      try {
        let res = await axios.request(config)
        console.log(res.data.data)
        this.staffName = res.data.data
      } catch (error) {
        console.log(error)
      }
    },
    async saveMemo() {
      const axios = require('axios')
      const qs = require('qs')
      let data = qs.stringify(
        {
          datetime: this.startDate,
          content: this.editMemoContent,
        },
        {
          encode: false,
        }
      )

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: '/api/attendance/text_memo/',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data,
      }

      try {
        let res = await axios.request(config)
        this.memoContent = this.editMemoContent
      } catch (error) {
        console.log(error)
      }
      this.dialogMemoEdit = false
    },
    openEventDialog(eventItem) {
      this.isEditing = true
      const eventParts = eventItem.label.split('｜')
      this.case_name = eventParts[0].trim()
      this.getCaseNum() // 根據個案名稱獲取個案編號
      this.event_type = Object.keys(this.groupedEvents()).find((key) =>
        this.groupedEvents()[key].some((item) => item.event_id === eventItem.event_id)
      )
      this.description = eventParts[1].trim()
      const timeRange = eventParts[2].trim()
      const [startTime, endTime] = timeRange.split(' - ')
      const today = moment().format('YYYY-MM-DD')
      this.startDate = this.formatDateFromInput(today)
      this.endDate = this.formatDateFromInput(today)
      this.startDateForMobile = today
      this.endDateForMobile = today
      this.startTime = startTime
      this.endTime = endTime

      this.selectedEvent = eventItem.event

      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.isEditing = false
      this.selectedEvent = null
      this.$refs.eventForm.reset()
    },
    async deleteEvent(eventItem) {
      this.eventToDelete = eventItem
      this.deleteConfirmDialog = true
    },
    async updateEvent() {
      if (!this.$refs.eventForm.validate()) return
      try {
        const axios = require('axios')
        const qs = require('qs')
        let start = moment(this.startDate + ' ' + this.startTime, 'YYYY-M-DD HH:mm').toDate()
        let end = moment(this.endDate + ' ' + this.endTime, 'YYYY-M-DD HH:mm').toDate()
        let formattedStart = moment(start).format()
        let formattedEnd = moment(end).format()

        let data = qs.stringify({
          event_type: this.event_type,
          description: this.description,
          start: formattedStart,
          end: formattedEnd,
          employee_id: this.staff_id,
        })

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `/api/attendance/events/${this.selectedEvent.event_id}/edit`,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          data: data,
        }

        let res = await axios.request(config)
        console.log(res.data)
        this.getEvents()
        this.closeDialog()
      } catch (error) {
        console.error('更新事件失敗:', error)
      }
    },
    openWeeklyEventDialog(event) {
      this.isEditing = true
      this.case_name = event.person
      this.getCaseNum()
      this.event_type = event.event_type
      this.description = event.description
      const start = moment(event.start)
      const end = moment(event.end)
      const startDateStr = start.format('YYYY-MM-DD')
      const endDateStr = end.format('YYYY-MM-DD')
      this.startDate = this.formatDateFromInput(startDateStr)
      this.endDate = this.formatDateFromInput(endDateStr)
      this.startDateForMobile = startDateStr
      this.endDateForMobile = endDateStr
      this.startTime = start.format('HH:mm')
      this.endTime = end.format('HH:mm')
      this.selectedEvent = event
      this.dialog = true
    },
    copyEvent(eventItem) {
      this.isEditing = false
      const eventParts = eventItem.label.split('｜')
      this.case_name = eventParts[0].trim()
      this.getCaseNum()
      this.event_type = Object.keys(this.groupedEvents()).find((key) =>
        this.groupedEvents()[key].some((item) => item.event_id === eventItem.event_id)
      )
      this.description = eventParts[1].trim()
      const today = new Date().toLocaleDateString().replaceAll('/', '-')
      this.startDate = today
      this.endDate = today
      if (this.isMobile) {
        this.startDateForMobile = this.formatDateForInput(today)
        this.endDateForMobile = this.formatDateForInput(today)
      }
      this.startTime = ''
      this.endTime = ''
      this.handleSelect = false
      this.selectedEvent = null
      this.dialog = true
    },
    copyWeeklyEvent(event) {
      this.isEditing = false
      this.case_name = event.person
      this.getCaseNum()
      this.event_type = event.event_type
      this.description = event.description
      const today = new Date().toLocaleDateString().replaceAll('/', '-')
      this.startDate = today
      this.endDate = today
      if (this.isMobile) {
        this.startDateForMobile = this.formatDateForInput(today)
        this.endDateForMobile = this.formatDateForInput(today)
      }
      this.startTime = ''
      this.endTime = ''
      this.handleSelect = false
      this.selectedEvent = null
      this.dialog = true
    },
    async deleteWeeklyEvent(event) {
      this.eventToDelete = event
      this.deleteConfirmDialog = true
    },
    async confirmDelete() {
      if (!this.eventToDelete) return

      try {
        const axios = require('axios')
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `/api/attendance/events/${this.eventToDelete.event_id}/delete`,
          headers: {},
        }
        await axios.request(config)
        this.getEvents()
        this.deleteConfirmDialog = false
        this.eventToDelete = null
      } catch (error) {
        console.error('刪除事件失敗:', error)
        this.deleteConfirmDialog = false
        this.eventToDelete = null
      }
    },
  },
  mounted() {
    this.detectMobile()
    const today = moment().format('YYYY-MM-DD')
    const todayFormatted = this.formatDateFromInput(today)
    if (this.isMobile) {
      this.startDateForMobile = today
      this.endDateForMobile = today
      this.startDate = todayFormatted
      this.endDate = todayFormatted
    }
    this.getCaseList()
    this.getEvents()
    this.getMemo()
    this.getAlertCount()
    this.getHighReiskList()
    this.getStaffName()
  },
  computed: {
    names() {
      return this.dataList.map((item) => item.name)
    },
  },
  created() {
    let staff = localStorage.getItem('staff')
    this.staff_id = JSON.parse(staff).id
  },
}
</script>
<style scoped>
.body {
  width: 95%;
}
.weekly-card-height {
  height: 300px;
}

.titles {
  display: flex;
  align-items: center;
  padding: 8px 4px;
}

.memo-display div {
  white-space: pre-wrap;
}

.stat-item {
  display: flex;
  align-items: center;
  font-size: 18px;
}

.high-risk-card {
  background-color: #f9f9e1;
  width: 90%;
  align-content: center;
}
</style>
